import { useCallback } from "react";
import { createNotificationContext } from "react-notification-provider";

export type NotificationType = "success" | "error" | "warning" | "info";

export interface Notification {
  title: string;
  message: string;
  duration?: number;
  type: NotificationType;
  allowDismiss?: boolean;
}

const { NotificationProvider, useNotificationQueue } =
  createNotificationContext<Notification>();

export { NotificationProvider, useNotificationQueue };

export const useNotification = () => {
  const queue = useNotificationQueue();
  const { add } = queue;

  const notify = useCallback(
    (data: Notification) => {
      add(`${Math.random()}`, data);
    },
    [add]
  );

  return {
    queue,
    notify,
  };
};
